import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";

const DEFAULT_LOGO = "/images/Tadarab-logo.png";

export default function LearningPathCardImage({
  src,
  alt = "",
  wrapperClassName = "",
  imageClassName = "",
}) {
  const currentOrganization = useSelector(
    (state) => state.auth.currentOrganization
  );
  const [cookies] = useCookies(["cookie-name"]);

  const orgLogo =
    currentOrganization?.orgLogo || cookies?.orgLogo || DEFAULT_LOGO;

  const [imageSrc, setImageSrc] = useState(src || orgLogo);
  const [isPlaceholder, setIsPlaceholder] = useState(!src);

  useEffect(() => {
    if (src) {
      setImageSrc(src);
      setIsPlaceholder(false);
    } else {
      setImageSrc(orgLogo);
      setIsPlaceholder(true);
    }
  }, [src, orgLogo]);

  const handleError = () => {
    if (!isPlaceholder) {
      setImageSrc(orgLogo);
      setIsPlaceholder(true);
      return;
    }

    if (imageSrc !== DEFAULT_LOGO) {
      setImageSrc(DEFAULT_LOGO);
    }
  };

  const wrapperClasses = [
    "learinig-path-card__img",
    isPlaceholder ? "learinig-path-card__img--placeholder" : "",
    wrapperClassName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClasses}>
      <img
        alt={alt}
        src={imageSrc}
        onError={handleError}
        className={imageClassName || undefined}
      />
    </div>
  );
}
